<template>
  <div class="isim-community-card-content isim-rounded">
    <slot v-if="hasHeader" name="header"></slot>
    <hr v-if="hasHeader && withHorizontalRules" />
    <slot></slot>
    <hr v-if="hasFooter && withHorizontalRules" />
    <slot v-if="hasFooter" name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: "CommunityCard",
  props: {
    withHorizontalRules: Boolean,
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header && !!this.$slots.header[0];
    },
    hasFooter() {
      return !!this.$slots.footer && !!this.$slots.footer[0];
    },
  },
};
</script>

<style scoped>
hr {
  margin: 0;
}

.isim-community-card-content {
  background-color: white;
  border-radius: 8px;
  border: 1px solid #dddddd;
}
</style>
